/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React Base Styles
import colors from "assets/theme-dark/base/colors";
import { ESCURO, TEXTO_COLORIDO_ESCURO } from "assets/coresTema";

const { transparent } = colors;

const iconButton = {
  styleOverrides: {
    root: {
      "&:hover": {
        backgroundColor: transparent.main,
      },
    },
    // Ícones de ação (editar, excluir, devolver...) com as cores "main" do tema somem no cinza dos blocos
    // (contraste 1 a 1,9): tons claros da mesma cor
    colorInfo: { color: TEXTO_COLORIDO_ESCURO.info },
    colorPrimary: { color: TEXTO_COLORIDO_ESCURO.primary },
    colorSecondary: { color: ESCURO.textoSecundario },
    colorError: { color: TEXTO_COLORIDO_ESCURO.error },
    colorSuccess: { color: TEXTO_COLORIDO_ESCURO.success },
    colorWarning: { color: TEXTO_COLORIDO_ESCURO.warning },
  },
};

export default iconButton;
